import React, { useState, useEffect } from 'react';
import { useInterval } from "../../utils/hooks";
import { useSmsSocket } from "../../utils/smsSocket";
import { parseUnreadMessages, isUnauthorized } from "../../utils/notifications";
import { useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import NewMessageIcon from "@mui/icons-material/EditOutlined";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import SmsContactsListItem from '../SmsContactsListItem';
import InputBase from '@mui/material/InputBase';

import { loadSmsConversations } from "../../utils/notifications";
  import {
    setConversationNotifications,
    setNotificationsLoading,
} from "../../store/features/notification/notificationSlice";
//   import { setCalls } from "../../store/features/calls/callSlice";
//   import { setVoicemails } from "../../store/features/voicemails/voicemailSlice";
import { setSmsConversations } from "../../store/features/smsConversations/smsConversationsSlice";
import { setSmsContact } from "../../store/features/smsConversations/smsContactSlice";
import { setSmsNewConversationActive } from "../../store/features/smsConversations/smsNewConversationSlice";
import { initNewSms } from "../../store/features/smsConversations/smsNewMessageSlice";
import { initNewMms } from "../../store/features/smsConversations/smsNewMmsSlice";
import { setFaxes } from "../../store/features/faxes/faxSlice";
import { setRecordings } from "../../store/features/recordings/recordingSlice";
import { setError } from "../../store/features/error/errorSlice";
import { useStyles } from "./styles";
import { conversationDisplayName } from "../../utils/contacts";
import { resetSession } from "../../store/features/session/sessionSlice";

const mapDispatchToProps = {
    // setCalls,
    // setVoicemails,
    setSmsConversations,
    setSmsContact,
    setSmsNewConversationActive,
    initNewSms,
    initNewMms,
    setFaxes,
    setRecordings,
    setConversationNotifications,
    setError,
    setNotificationsLoading,
    resetSession,
};

const SmsContactsList = (props) => {
    const {
        smsConversations,
        smsNewConversation,
        session,
        resetSession,
        setSmsConversations,
        setConversationNotifications,
        setSmsContact,
        smsContact,
        setSmsNewConversationActive,
        initNewSms,
        initNewMms,
        setValue,
        history,
        phonebook,
        externalPhonebook,
        personalPhonebook,
      } = props;

    const { classes } = useStyles();
    const [filterText, setFilterText] = useState('');

    const defaultValues = {
        server: session.lastServer,
        token: session.token,
    };

    const location = useLocation();
    const matches = location.pathname.match(/(?:^\/dashboard\/sms\/sms\/all)\/(?<conversation_id>[\d]+-[\d]+-[\d]+)/g);

    let urlConversationId = "";
    if (matches) {
        urlConversationId = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
        history.push(`/dashboard/sms/sms/all`);
    }

    // Live updates: the dashboard reloads the conversations on every SMS
    // event (see dashboard.js), so here we only need the connection state.
    // Polling stays as a fallback and slows down while the socket is connected.
    const socketConnected = useSmsSocket(defaultValues, () => {});

    useInterval(() => {
        refetchNotifications();
    }, socketConnected ? 300000 : 60000);

    const refetchNotifications = () => {
        let fetchSmsConversations = loadSmsConversations(defaultValues, setSmsConversations);

        Promise.all([fetchSmsConversations])
            .then((res) => {
                if (isUnauthorized(res)) {
                    resetSession();
                    history.push('/login');
                    return;
                }

                if (Array.isArray(res[0].Conversations) && res[0].Conversations.length) {
                    initNewSms("new")
                    initNewMms("new")
                    if (urlConversationId && (!smsContact.id || smsContact.id !== urlConversationId)) {
                        let item = res[0].Conversations.find(item => item.conversation_id === urlConversationId);
                        initNewSms(item.conversation_id)
                        initNewMms(item.conversation_id)
                        setSmsContact(item);
                        setValue(item.number);
                    }
                    else {
                        if (!smsContact.id) {
                            // by default always open the first conversation
                            // history.push(`/dashboard/sms/sms/all/${res[0].Conversations[0].conversation_id}`);
                            initNewSms(res[0].Conversations[0].conversation_id)
                            initNewMms(res[0].Conversations[0].conversation_id)
                            setSmsContact(res[0].Conversations[0]);
                        }
                        setValue(res[0].Conversations[0].number);
                    }
                }
                setConversationNotifications(parseUnreadMessages(res[0].Conversations));
                setNotificationsLoading(false);
            })
            .catch((err) => {
                console.error(err);
            });
    }; 

    const clearCurrentNotifications = () => {
        try {
            refetchNotifications();
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        clearCurrentNotifications();
        // eslint-disable-next-line
      }, [smsContact]);

    const handleNewConversation = () => {
        setSmsNewConversationActive(true);
        setSmsContact(smsNewConversation);
        setValue("")
    }

    const query = filterText.trim().toLowerCase();
    const phonebooks = [personalPhonebook, phonebook, externalPhonebook];
    const visibleConversations = smsConversations.filter(f =>
        query === '' ||
        conversationDisplayName(f, phonebooks).toLowerCase().includes(query) ||
        (f.number || '').includes(query) ||
        (f.number_pretty || '').includes(query) ||
        ((f.lastMessage && f.lastMessage.message) || '').toLowerCase().includes(query)
    );

    return (
        <div key="smsContactsList" className={classes.smsContactsList}>
            <div key="smsContactsSearch" className={classes.smsContactsSearch}>
                <div className={classes.listHeader}>
                    <div className={classes.listTitle}>Messages</div>
                    <Tooltip title="New message">
                        <IconButton
                            aria-label="new message"
                            className={classes.newSmsButton}
                            onClick={handleNewConversation}
                            size="small">
                            <NewMessageIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </div>
                <div className={classes.searchField}>
                    <SearchIcon fontSize="small" />
                    <InputBase
                        key="smsContactsSearch_Input"
                        className={classes.smsContactsSearchInput}
                        placeholder="Search conversations"
                        value={filterText}
                        onChange={event => setFilterText(event.target.value)}
                        slotProps={{ input: { 'aria-label': 'search conversations' } }}
                    />
                    {filterText !== '' && (
                        <IconButton
                            size="small"
                            className={classes.searchClear}
                            aria-label="clear search"
                            onClick={() => setFilterText('')}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    )}
                </div>
            </div>
            <div className={classes.items}>
                { smsNewConversation.active
                                  ? <SmsContactsListItem
                                        key='New message'
                                        data={smsNewConversation}
                                    />
                                  : null }
                {visibleConversations.map(item =>
                    <SmsContactsListItem
                        key={item.conversation_id}
                        data={item}
                        setValue={setValue}
                    />
                )}
                {visibleConversations.length === 0 && (
                    <div className={classes.emptyState}>
                        {query !== '' ? `No conversations match "${filterText.trim()}"` : "No conversations yet"}
                    </div>
                )}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        session: state.session,
        smsConversations: state.smsConversations,
        smsNewConversation: state.smsNewConversation,
        smsContact: state.smsContact,
        notifications: state.notifications,
        phonebook: state.phonebook,
        externalPhonebook: state.externalPhonebook,
        personalPhonebook: state.personalPhonebook,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SmsContactsList);